import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '../../core/i18n/translate.pipe';

export interface UnlinkRelationDialogData {
  relationName: string;
}

@Component({
  selector: 'app-unlink-relation-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, TranslatePipe],
  template: `
    <h2 mat-dialog-title>{{ 'relationUnlink.title' | t }}</h2>
    <mat-dialog-content>
      <p>{{ 'relationUnlink.message' | t:{ name: data.relationName } }}</p>
      <p>{{ 'relationUnlink.historyInfo' | t }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="dialogRef.close(false)">{{ 'common.cancel' | t }}</button>
      <button mat-flat-button color="warn" type="button" (click)="dialogRef.close(true)">
        {{ 'relationUnlink.action' | t }}
      </button>
    </mat-dialog-actions>
  `
})
export class UnlinkRelationDialogComponent {
  constructor(
    readonly dialogRef: MatDialogRef<UnlinkRelationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) readonly data: UnlinkRelationDialogData
  ) {}
}
